import React, { useState } from 'react';
import Icon from '../IconBase/Icon';
import { translate } from '../../Services/translation';
import {
  LIST_TYPE_GALLERY,
  LIST_TYPE_LIST,
  LIST_TYPE_TABLE,
} from '../ProductsView/ProductsView';
import { useDispatch, useSelector } from 'react-redux';
import { setListType } from '../../Actions/ProductsView.action';
import(`./styles/${window.__litium.themeName}.scss`);

const TogglerOption = ({
  id,
  onClick,
  activeOption,
  text,
  icon,
  iconActive,
}) => {
  return (
    <div
      id={id}
      onClick={() => onClick(id)}
      className={
        activeOption == id
          ? 'product-sorting__view-options--button product-sorting__view-options--button--active'
          : 'product-sorting__view-options--button'
      }
    >
      {activeOption == id ? iconActive : icon}
      {text}
    </div>
  );
};

const ListingLayoutTogglers = () => {
  const { listType } = useSelector((state) => state.productsView);
  const dispatch = useDispatch();

  const setActiveOption = (id) => {
    dispatch(setListType(id));
  };

  return (
    <>
      <TogglerOption
        id={LIST_TYPE_GALLERY}
        activeOption={listType}
        text={''}
        icon={<Icon iconCode="grid_view" />}
        iconActive={
          <Icon iconCode="grid_view" iconClass="layout-toggle__active" />
        }
        onClick={(id) => setActiveOption(id)}
      />
      <TogglerOption
        id={LIST_TYPE_TABLE}
        activeOption={listType}
        text={''}
        icon={<Icon iconCode="view_list" />}
        iconActive={
          <Icon iconCode="view_list" iconClass="layout-toggle__active" />
        }
        onClick={(id) => setActiveOption(id)}
      />
    </>
  );
};

export default ListingLayoutTogglers;
